import React, { useState, Component } from 'react';





class Divider extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    // this.state = {
    //   example: someInfo,
    // };
  }
  

  render() {
    const { width, height, cx, content, headingLevel, icon } = this.props;
    

    const dividerText = new Array(500).fill(content).join(` ${icon} `);
    
    // console.log(dividerText)


    return (
      <div className={`divider large-h-5 w-${width} h-${height} ${cx}`}>
        <span className=" ws-no-wrap pb-m flex">{dividerText}</span>
      </div>
    
    );
  }
}


export default Divider;